"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { WarningCircle } from "@phosphor-icons/react";

export function PlazaConnectionError() {
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  return (
    <div role="alert" className="col-span-full grid place-items-center rounded-[var(--radius-card)] border border-[var(--color-line)] bg-[var(--color-raised)] px-6 py-14 text-center">
      <WarningCircle size={30} className="text-[var(--color-warm)]" aria-hidden="true" />
      <h2 className="mt-4 text-base font-semibold">暂时无法连接形象广场</h2>
      <p className="mt-2 max-w-md text-sm leading-6 text-[var(--color-muted)]">请检查网络连接后重试，形象资料暂时无法加载。</p>
      <button type="button" disabled={pending} onClick={() => startTransition(() => router.refresh())} className="btn-silver mt-5 rounded-full px-6 py-2 text-sm disabled:opacity-60">
        {pending ? "正在重试…" : "重新加载"}
      </button>
    </div>
  );
}
